import { Dispatch, SetStateAction, useState } from "react"

import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { IAppError } from "../../../../errors/errorTypes"
import { snackbar } from "../../../../utils/general/generalUtils"
import { postClientProtected } from "../../clients/clients"
import { INVITE_USER } from "../../urls/private"

interface IRaiseAlertHook {
    isSending: boolean
    error: IAppError | undefined
    postInvite: (email: string) => Promise<void>
}

/**
 * Provides functions and logic for inviting a user to join an org
 * @returns {IRaiseAlertHook} - loading and error states.
 */
const useInviteUser = (
    setIsOpen: Dispatch<SetStateAction<boolean>>
): IRaiseAlertHook => {
    const [isSending, setIsSending] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)

    const postInvite = async (email: string): Promise<void> => {
        try {
            setIsSending(true)

            // Build response
            const body = {
                email,
                claim_domain: false,
                new_user_management_option: "add",
            }
            await postClientProtected(INVITE_USER, body)

            snackbar("Invite successfully sent", "success")
            setError(undefined)
            setIsOpen(false)
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            setError(errorObj)
        } finally {
            setIsSending(false)
        }
    }

    return {
        error,
        isSending,
        postInvite,
    }
}

export default useInviteUser

// TODO - error prase
